import List from "components/list";
import React from "react";
import { getColumnsByType } from "./columns";
import { startOfMonth, endOfMonth } from "date-fns";
import { formatDateForAPI } from "utils/utils";

export default function JobTypeListing({
  type,
  onFiltersChange,
  title = `${type} Projects`,
  filters = () => ({}),
  renderContent = () => { },
}) {
  const fields = [
    "id",
    "name",
    "project_id",
    {
      sales_coordinator: ["id", "first_name", "last_name", "avatar"],
      account_manager: ["id", "first_name", "last_name", "avatar"],
    },
    {
      client: [
        "id",
        "first_name",
        "last_name",
        {
          company_id: ["id", "name"],
        },
      ],
    },

    {
      jobs: [
        "id",
        "name",
        "type",
        "status",
        {
          employees: [
            "id",
            {
              employee: [
                "id",
                {
                  department: ["id", "name"],
                },
              ],
            },
          ],
        },
        {
          billables: [
            "id",
            "amount",
            "adjusted_amount",
            "collected_date",
            "billing_date",
            "currency",
            "type",
          ],
        },
      ],
    },
  ];

  const columns = getColumnsByType(type);

  // Get current month date range for default filtering
  const now = new Date();
  const currentMonthStart = formatDateForAPI(startOfMonth(now));
  const currentMonthEnd = formatDateForAPI(endOfMonth(now));

  const defaultFilters = {
    jobs: {
      type: { _eq: type },

      billables: {
        status: {
          _eq: "collected",
        },
        collected_date: {
          _gte: currentMonthStart,
          _lte: currentMonthEnd,
        },
      },
    },
    deep: {
      jobs: {
        _limit: -1,
        _filters: {
          billables: {
            status: {
              _eq: "collected",
            },
            collected_date: {
              _gte: currentMonthStart,
              _lte: currentMonthEnd,
            },
          },
        },
        billables: {
          _filters: {
            status: {
              _eq: "collected",
            },
            collected_date: {
              _gte: currentMonthStart,
              _lte: currentMonthEnd,
            },
          },
          _limit: -1,
        },
      },
    },
  };

  return (
    <List
      title={title}
      endPoint="projects"
      filters={defaultFilters}
      onFiltersChange={onFiltersChange}
      columns={columns}
      meta={{ fields }}
      perPage={25}
      href={null}
      storageKey={`projects-${type}`}
      sortOrder="desc"
      sortBy="date_created"
      renderFilters={filters}
      renderContent={renderContent}
    />
  );
}
